import type { FilterOptionsState } from '@mui/material/useAutocomplete';
import { matchSorter } from 'match-sorter';

// Searches across multiple columns of data using a multi-word string
// via https://github.com/kentcdodds/match-sorter#match-many-words-across-multiple-fields-table-filtering
export function filterOptions<Option = unknown>(keys: string[]) {
  return (options: Option[], { inputValue }: FilterOptionsState<Option>) => {
    if (!inputValue?.length) {
      return options;
    }

    const terms = inputValue.split(' ');

    // reduceRight will mean sorting is done by score for the _first_ entered word.
    return terms.reduceRight((results, term) => matchSorter(results, term, { keys }), options);
  };
}
